import { TAuthority } from 'types/authority.types';

let CURRENT: string[];
let listeners: (() => void)[] = [];
export const CURRENT_PERMISSIONS = 'permissions';

/**
 * Custom store to to get initialized value of auth
 */
export const authorityStore = {
  setAuthority(newAuth: TAuthority[]) {
    CURRENT = newAuth;
    localStorage.setItem(CURRENT_PERMISSIONS, JSON.stringify(newAuth));

    emitChange();
  },
  subscribe(callback: () => void) {
    listeners = [...listeners, callback];

    return () => {
      listeners = listeners.filter((l) => l !== callback);
    };
  },
  getSnapshot() {
    return CURRENT as TAuthority[];
  },
};

/**
 * Function to call all listeners
 */
function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

/**
 * Listen for storage changes for authority key
 * @param e event
 */
function storageListener(e: StorageEvent) {
  if (e.key === CURRENT_PERMISSIONS && e.newValue !== e.oldValue) {
    const result = parseAuthStorage(e.newValue);

    if (result) {
      authorityStore.setAuthority(result);
    }
  }
}

function parseAuthStorage(ls: string | undefined | null) {
  let result: TAuthority[] = [];

  if (!ls) {
    return result;
  }

  try {
    const parsed = JSON.parse(ls);
    result = Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.log('Authority is not valid');
  }

  return result;
}

/**
 * Function to load initial permissions from LS
 */
function initAuth() {
  // Reset listener for multi window
  window.removeEventListener('storage', storageListener);

  // Init storage
  const ls = localStorage.getItem(CURRENT_PERMISSIONS);
  const result = parseAuthStorage(ls);

  // Set store and add listener for storage changes
  authorityStore.setAuthority(result);
  window.addEventListener('storage', storageListener, false);
}

initAuth();
export default authorityStore;
